import { useJsApiLoader } from "@react-google-maps/api";

const MAPS_LIBRARIES = ["places"];

/*
 * Every Google feature on this screen — the address suggestions on the Details tab and
 * the map on the Location tab — goes through the Maps JavaScript API, because it is the
 * only interface that accepts this key: it carries HTTP-referrer restrictions, which
 * Google's REST web services reject outright.
 *
 * So the script is requested once, here at the page level, rather than by whichever tab
 * happens to be open. Loading it inside the map meant the address search on the other
 * tab had no API to call at all.
 */
export const useGoogleMapsScript = () => {
  const apiKey =
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
    "AIzaSyAa3Et--Rjr1Ut1l-D4Vj_aD1CAt9zLoXk";

  const { isLoaded, loadError } = useJsApiLoader({
    id: "practice-details-google-maps",
    googleMapsApiKey: apiKey,
    libraries: MAPS_LIBRARIES,
  });

  if (loadError) {
    console.error("Google Maps script failed to load:", loadError);
  }

  return {
    apiKey,
    isReady: isLoaded && !loadError,
    // Terminal: no key, or the script will not load. Anything else is still in flight.
    hasFailed: !apiKey || !!loadError,
    isLoading: !isLoaded && !loadError,
  };
};
